import * as RadixTabs from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';
import { cx } from '../cx.js';

export interface TabItem {
  value: string;
  label: string;
  /** Numero mostrato accanto all'etichetta (es. iscritti). */
  count?: number;
}

export interface TabsProps {
  items: TabItem[];
  value: string;
  onValueChange: (value: string) => void;
  children: ReactNode;
  ariaLabel: string;
  className?: string;
  /** Elemento in coda alla riga delle schede, es. il bottone del manuale. */
  aiuto?: ReactNode;
}

/** Schede accessibili (Radix): frecce per spostarsi, pannello annunciato. */
export function Tabs({ items, value, onValueChange, children, ariaLabel, className, aiuto }: TabsProps) {
  return (
    <RadixTabs.Root value={value} onValueChange={onValueChange} className={cx('flex flex-col gap-6', className)}>
      <RadixTabs.List aria-label={ariaLabel} className="flex gap-1 border-b border-border overflow-x-auto">
        {items.map((t) => (
          <RadixTabs.Trigger
            key={t.value}
            value={t.value}
            className={cx(
              't-label min-h-[44px] px-4 py-2 -mb-px border-b-2 border-transparent text-ink-muted whitespace-nowrap',
              'hover:text-ink data-[state=active]:text-ink data-[state=active]:border-accent',
            )}
          >
            {t.label}
            {typeof t.count === 'number' && <span className="ml-2 t-caption text-ink-muted">{t.count}</span>}
          </RadixTabs.Trigger>
        ))}
        {aiuto && <div className="ml-auto flex items-center pl-2">{aiuto}</div>}
      </RadixTabs.List>
      {children}
    </RadixTabs.Root>
  );
}

export function TabPanel({ value, children, className }: { value: string; children: ReactNode; className?: string }) {
  return (
    <RadixTabs.Content value={value} className={cx('flex flex-col gap-6 focus:outline-none', className)}>
      {children}
    </RadixTabs.Content>
  );
}
